import { useQueryClient } from "@tanstack/react-query";

import { useDeleteControlProgramsTagCategoriesTagCategoryId } from "api/generated/control-program/control-program";

import { CONTROL_PROGRAM_TAGS_QUERY_KEY } from "./useControlProgramTagsQuery";

export const useDeleteControlProgramTagCategoryMutation = () => {
    const queryClient = useQueryClient();

    return useDeleteControlProgramsTagCategoriesTagCategoryId({
        mutation: {
            onSuccess: () =>
                queryClient.invalidateQueries({
                    queryKey: [CONTROL_PROGRAM_TAGS_QUERY_KEY],
                }),
        },
    });
};
